var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"max-height":"500px","overflow":"auto"}},[_c('div',{ref:"editRef"})])
}
var staticRenderFns = []

export { render, staticRenderFns }